// src/App.js

import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { Security } from '@okta/okta-react';
import { Toast, ThemeProvider, cspTheme } from 'portal-commons';
import configureStore from './store/configureStore';
import Favicon from 'react-favicon';
import './assets/styles/app.scss';
import { S3_ASSETS_PATH } from './constants';
import AppWithRouterAccess from './AppWithRouterAccess';
import datadog from './utils/datadog';
import LoadingModal from './shared_elements/containers/LoadingModal';

import { AuthContextProvider } from './contexts/auth';

const store = configureStore();

datadog.init();
const userInfoJsonString = localStorage.getItem('userInfo');
if (userInfoJsonString) {
  const userInfo = JSON.parse(userInfoJsonString);
  !datadog.hasUser() && datadog.setUser(userInfo);
}

const App = ({ oktaAuth }) => {
  const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    if (!originalUri) {
      window.location.replace('/');
      return;
    }
    const origin = new URL(originalUri, window.location.origin);
    const pathname =
      origin.pathname === '/'
        ? '/'
        : `/?redirectUri=${encodeURIComponent(originalUri)}`;
    window.location.replace(pathname);
  };

  const onAuthRequired = () => {
    window.location.replace('/login');
  };

  return (
    <div className="App">
      <ThemeProvider theme={cspTheme}>
        <Favicon url={`${S3_ASSETS_PATH}/images/favicon-48x48.ico`} />
        <Provider store={store}>
          <AuthContextProvider>
            <LoadingModal />
            <Toast />
            <Router>
              <Security
                oktaAuth={oktaAuth}
                restoreOriginalUri={restoreOriginalUri}
                onAuthRequired={onAuthRequired}
              >
                <AppWithRouterAccess />
              </Security>
            </Router>
          </AuthContextProvider>
        </Provider>
      </ThemeProvider>
    </div>
  );
};
export default App;
